export default __webpack_public_path__ + "static/media/img_24.c7ce3cb1.JPG";